module.exports = require("./../../_gen/starling/utils/Align");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/Align.js
// module id = 241
// module chunks = 0